// src/components/ValentinPanel.js
import React, { useState } from 'react';
import './ValentinPanel.css'; // Importar estilos
import loveImage from '../assets/valentin-image.jpg'; // Importar la imagen

const ValentinPanel = ({ onRestart }) => {
  const [response, setResponse] = useState(null);

  const handleAccept = () => {
    setResponse('accepted');
  };

  const handleReject = () => {
    onRestart();
  };

  return (
    <div className="valentin-panel">
      {response === 'accepted' ? (
        <div className="love-message">
          <h2>¡Te amo mucho, mi amor! 💖</h2>
          <p>Eres lo mejor que me ha pasado en la vida. 💕</p>
          <div className="hearts">
            {Array.from({ length: 20 }).map((_, index) => (
              <div key={index} className="heart">💖</div>
            ))}
          </div>
          <img src={loveImage} alt="Amor" className="love-image" /> {/* Imagen debajo del mensaje */}
          <button onClick={onRestart}>Jugar de nuevo</button>
        </div>
      ) : (
        <>
          <h2>¿Quieres ser mi Valentín el 14 de febrero?</h2>
          <button onClick={handleAccept}>Sí</button>
          <button onClick={handleReject}>No</button>
        </>
      )}
    </div>
  );
};

export default ValentinPanel;